import React from 'react';
import EventList from '@/src/components/events/EventList';
import { useHistory, useLocation } from 'react-router-dom';
import { RoutePath } from '@/src/RoutePath';

export const MyEventsPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  if(location.pathname === RoutePath.MY_EVENTS) {
    history.push(RoutePath.EVENTS);
    return null;
  }
  return <EventList />;
};
